import { render, staticRenderFns } from "./CustomLayout.vue?vue&type=template&id=675329bf&"
import script from "./CustomLayout.vue?vue&type=script&lang=js&"
export * from "./CustomLayout.vue?vue&type=script&lang=js&"
import style0 from "./CustomLayout.vue?vue&type=style&index=0&id=675329bf&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports